import React from 'react';
import { Button } from 'antd';
import { AudioOutlined } from '@ant-design/icons';
import { useApp } from '../../contexts/AppContext';
import { useVapi } from '../../hooks/useVapi';
import Waveform from './Waveform';
import './VoiceInput.css';

// Custom white square icon for stop button
const WhiteSquareIcon: React.FC = () => (
  <div style={{
    width: '16px',
    height: '16px',
    backgroundColor: '#ffffff',
    borderRadius: '2px'
  }} />
);

const VoiceInput: React.FC = () => {
  const { state } = useApp();
  const { callActive, status, toggleCall, isProcessing, volumeLevel } = useVapi();

  const handleVoiceButtonClick = () => {
    if (callActive) {
      toggleCall(); // Stop Vapi call
    } else {
      toggleCall(); // Start Vapi call
    }
  };

  if (callActive && status === 'Connected') {
    return (
      <div className="voice-input-container recording">
        <div className="recording-interface">
          <div className="waveform-container">
            <Waveform volumeLevel={volumeLevel} />
            <Button
              type="primary"
              icon={<WhiteSquareIcon />}
              onClick={handleVoiceButtonClick}
              className="stop-button centered"
              size="large"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="voice-input-container">
      <Button
        type="primary"
        icon={<AudioOutlined />}
        onClick={handleVoiceButtonClick}
        className="voice-button"
        size="large"
        disabled={state.isProcessing || isProcessing}
        loading={isProcessing}
      />
    </div>
  );
};

export default VoiceInput;
